import { render, staticRenderFns } from "./PublicServiceAnnouncement.vue?vue&type=template&id=57377ba4&scoped=true&"
import script from "./PublicServiceAnnouncement.vue?vue&type=script&lang=js&"
export * from "./PublicServiceAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./PublicServiceAnnouncement.vue?vue&type=style&index=0&id=57377ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57377ba4",
  null
  
)

export default component.exports